<script>
import { defineComponent } from 'vue'
import elementState from '../publish/elementstate.vue'
import VTooltipWrapper from '../../common/v-tooltip-wrapper.vue'

export default defineComponent({
    name: 'TextEllipsisWithTooltip',
    components: { VTooltipWrapper, elementState },
    props: {
        text: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            hover: false,
            tooltipEnabled: true,
            nudgeLeft: 0,
            timeoutHandle: null,
            tooltipShowing: false
        }
    },
    methods: {
        isTextOverflowed(element) {
            return element && (element.offsetWidth < element.scrollWidth)
        },
        forceShowTooltip() {
            if (this.tooltipEnabled) {
                if (!this.tooltipShowing) {
                    this.tooltipShowing = true
                    return true
                }
            }
            return false
        },
        tooltipVisibilityHandler() {
            if (!this.forceShowTooltip()) {
                this.tooltipEnabled = this.isTextOverflowed(this.$refs.container)
                this.forceShowTooltip()
            }
        },
        forceHideTooltip() {
            if (this.tooltipShowing) {
                this.tooltipShowing = false
                return true
            }
        }
    },
    watch: {
        async hover(val) {

            clearTimeout(this.timeoutHandle)
            this.timeoutHandle = null

            if (!val) {

                // Run text overflow check again after 37ms.
                // Sometimes the tooltip doesn't hide, this way we can force it if it's not hidden yet.
                this.timeoutHandle = setTimeout(this.forceHideTooltip, 107)
                return
            }

            await this.$nextTick()
            await this.$nextTick()

            if (!this.$refs.container) return

            this.tooltipEnabled = this.isTextOverflowed(this.$refs.container)
            this.nudgeLeft = this.$refs.container.offsetWidth + 14

            // Run text overflow check again after 37ms.
            // Sometimes the tooltip doesn't show, this way we can force it if it's not shown yet.
            this.timeoutHandle = setTimeout(this.tooltipVisibilityHandler, 37)
        }
    }
})
</script>

<template>
    <v-tooltip-wrapper v-model="tooltipShowing"
                       :disabled="!tooltipEnabled"
                       :nudge-left="nudgeLeft"
                       content-class="tooltip-glass tooltip-white elevation-2 text-ellipsis-tooltip-content"
                       tooltip-position="right"
                       transition="fade-transition">
        <template #activator="{ on, attrs }">
            <span ref="container"
                  class="text-ellipsis-container"
                  v-bind="{...$attrs, ...attrs}"
                  @mouseleave="hover = false"
                  @mouseover="hover = true"
                  v-on="{...$listeners, ...on}">
                {{ text }}
            </span>
        </template>
        {{ text }}
    </v-tooltip-wrapper>
</template>

<style>
.text-ellipsis-container {
    min-width: 36px;

    color: black;
    //font-weight: 600;

    transition: color var(--title-background-transition-duration) ease-out;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    cursor: default;
}

/*noinspection CssUnusedSymbol*/
.text-ellipsis-tooltip-content {
    border-radius: 6px !important;
    font-weight: 600;
    color: black;
    font-size: 13px;
    padding: unset;
    padding-block: 5px;
    padding-inline-start: 4px;
    padding-inline-end: 8px;
}
</style>

